import BaseModelAPI from '../BaseModelAPI';

export default class SubcontractGoodReceiptDetail extends BaseModelAPI {
	static entity = 'subcontractgoodreceiptdetail';
	static entityName = 'subcontractgoodreceiptdetail';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.subcontractGoodReceiptId = '';
			this.subcontractGoodReceipt = {};
			this.id = '';
			this.controlCardId = '';
			this.controlCard = {};
			this.isComplete = false;
			this.caseQty = 0;
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.isScanned = '';
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}